import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../../lib/redux/hooks'
import { CustomAccordion } from '../../../../ui/molecules/accordion'
import { ButtonComponent } from '../../../../ui/molecules/button/newButton'
import { Calendar } from '../../../../ui/molecules/calendar'
import { ProtocolSelectByObject } from '../../../../ui/molecules/ProtocolSelectByObj'
import { ProtocolSelectFromDate } from '../../../../ui/molecules/ProtocolSelectFromDate'
import { CustomRadio } from '../../../../ui/molecules/radioButton'
import { MadfarmStaticSelect } from '../../../../ui/molecules/select/newSelect/static'
import TextArea from '../../../../ui/molecules/textArea'
import { BusinessRegisterRequestMotivationOptions, BusinessRegisterTypologyRequestOptions } from '../../../../utils'
import { DownloadRegisterSubmissionDocx, GetAllBusinessRegisters, resetGetAllBusinessRegistersStatus, setBusinessRegisterCreationReleaseRegister, setBusinessRegisterUpdateNote, setBusinessRegisterUpdateReleaseDate, setBusinessRegisterUpdateReleaseProtocolId, setBusinessRegisterUpdateRequestProtocolId, setBusinessRegisterUpdateRequestReason, setBusinessRegisterUpdateRequestType, setLatestAvailableDate } from '../slice'
import { BusinessRegisterReleaseRegister } from '../dataService/dto'
import '../styles.scss'

export function EditRegistroForms() {
    const dispatch = useAppDispatch()
    const userState = useAppSelector(state => state.users)
    const sessionState = useAppSelector(state => state.session)
    const registerState = useAppSelector(state => state.register)
    const [closeFlag, setCloseFlag] = useState<string>('IDLE')
    const [expanded, setExpanded] = useState<string>('panel1')

    const handleToggleAccordion = (panel: string) => {
        setExpanded(prev => (prev === panel ? '' : panel))
    }

    useEffect(() => {
        dispatch(GetAllBusinessRegisters({ itemsPerPage: 1, page: 0, order: false, headQuarter: userState.findMeResponse.headQuarterInfo?.code }))

        setCloseFlag(registerState.businessRegisterUpdateRequest.releaseRegister === BusinessRegisterReleaseRegister.PROTOCOLLO_RILASCIO ? 'CLOSE1' : 'CLOSE2')
    }, [])

    useEffect(() => {
        if (registerState.getAllBusinessRegistersStatus === 'successfully' &&
            registerState.getAllBusinessRegistersResponse !== undefined
        ) {
            dispatch(resetGetAllBusinessRegistersStatus())
            const latestDate: Date = new Date(registerState.getAllBusinessRegistersResponse.data[0].releaseDate)
            latestDate.setDate(latestDate.getDate() + 1)
            dispatch(setLatestAvailableDate(latestDate))
        }
    }, [registerState.getAllBusinessRegistersStatus])

    return (
        <div className="p-6 flex flex-col gap-6">
            <CustomAccordion
                id="panel1"
                title={<span className="text-uppercase text-white label-input">Dati richiesta RE002</span>}
                expanded={expanded === 'panel1'}
                onChange={() => handleToggleAccordion('panel1')}
                detailsClassName="flex flex-col gap-4"
            >
                <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
                    <MadfarmStaticSelect
                        label="Motivo richiesta"
                        noOptionsMessage="Nessun motivo disponibile"
                        error={registerState.businessRegisterErrors.requestReason}
                        errorLabel='Motivazione mancante'
                        placeholder={'Seleziona motivazione...'}
                        options={BusinessRegisterRequestMotivationOptions}
                        value={registerState.businessRegisterUpdateRequest.requestReason}
                        onChange={(value) => dispatch(setBusinessRegisterUpdateRequestReason(value))}
                    />
                    <ProtocolSelectByObject
                        title="Protocollo Richiesta [RRA]"
                        error={registerState.businessRegisterErrors.requestProtocolId}
                        errorLabel='Protocollo mancante'
                        type='entry'
                        objectId='88'
                        customerId={sessionState.selected.customerId!}
                        value={registerState.businessRegisterUpdateRequest.requestProtocolId}
                        placeholder='Seleziona protocollo...'
                        onChange={(value) => dispatch(setBusinessRegisterUpdateRequestProtocolId(value))}
                    />
                </div>

                <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
                    <MadfarmStaticSelect
                        label="Tipo di richiesta"
                        noOptionsMessage='Nessun risultato trovato'
                        error={registerState.businessRegisterErrors.requestType}
                        errorLabel='Tipologia mancante'
                        placeholder={'Seleziona tipologia...'}
                        options={BusinessRegisterTypologyRequestOptions}
                        value={registerState.businessRegisterUpdateRequest.requestType}
                        onChange={(value) => dispatch(setBusinessRegisterUpdateRequestType(value))}
                    />
                    <MadfarmStaticSelect
                        label="Notifica"
                        noOptionsMessage='Nessun risultato trovato'
                        placeholder={'Seleziona tipologia...'}
                        options={[{ value: '1', label: 'Tipo 1' }]}
                        onChange={(value) => { }}
                    />
                </div>
            </CustomAccordion>

            <CustomAccordion
                id="panel2"
                title={<span className="text-uppercase text-white label-input">Rilascio registro</span>}
                expanded={expanded === 'panel2'}
                onChange={() => handleToggleAccordion('panel2')}
                detailsClassName="flex flex-col gap-4"
            >
                <div className='pb-4 border-b border-neutral-200'>
                    <div className='flex flex-col gap-4'>
                        <div className='flex items-center'>
                            <div className='mt-5'>
                                <CustomRadio
                                    options={[{ label: '', value: 'CLOSE1' }]}
                                    selectedValue={closeFlag}
                                    onChange={(value) => {
                                        setCloseFlag(value)
                                        dispatch(setBusinessRegisterCreationReleaseRegister(BusinessRegisterReleaseRegister.PROTOCOLLO_RILASCIO))
                                        dispatch(setBusinessRegisterUpdateReleaseDate(undefined))
                                    }}
                                    id={'close1'}
                                    name={'close1'}
                                />
                            </div>
                            <ProtocolSelectFromDate
                                title='Protocollo di rilascio'
                                type='departure'
                                disabled={closeFlag !== 'CLOSE1'}
                                fromDate={registerState.businessRegisterUpdateRequest.releaseDate}
                                customerId={sessionState.selected.customerId!}
                                placeholder='Scegli protocollo di rilascio...'
                                defaultValue={registerState.businessRegisterUpdateRequest.releaseProtocolId}
                                value={registerState.businessRegisterUpdateRequest.releaseProtocolId}
                                onChange={(value) => dispatch(setBusinessRegisterUpdateReleaseProtocolId(value))}
                            />
                        </div>
                        <div className='flex items-center'>
                            <div className='mt-5'>
                                <CustomRadio
                                    options={[{ label: '', value: 'CLOSE2' }]}
                                    selectedValue={closeFlag}
                                    onChange={(value) => {
                                        setCloseFlag(value)
                                        dispatch(setBusinessRegisterCreationReleaseRegister(BusinessRegisterReleaseRegister.CONSEGNATI_DAL_TECNICO_ISPETTORE))
                                        dispatch(setBusinessRegisterUpdateReleaseProtocolId(undefined))
                                    }}
                                    id={'close2'}
                                    name={'close2'}
                                />
                            </div>
                            <Calendar
                                label="Consegnati dal tecnico ispettore nel corso della visita ispettiva / Data"
                                selected={closeFlag === 'CLOSE2' ? registerState.businessRegisterUpdateRequest.releaseDate : undefined}
                                onChange={(date) => dispatch(setBusinessRegisterUpdateReleaseDate(date))}
                                minDate={registerState.latestAvailableDate}
                                disabled={closeFlag !== 'CLOSE2'}
                            />
                        </div>
                    </div>
                </div>

                <TextArea
                    value={registerState.businessRegisterUpdateRequest.note}
                    onChangeText={(text) => dispatch(setBusinessRegisterUpdateNote(text))}
                    label="Note"
                />

                <div className='mt-2'>
                    <div className="flex flex-wrap gap-3">
                        <ButtonComponent
                            size="sm"
                            iconPosition="off"
                            variant="solid"
                            label="Crea Word fase di avvio"
                            color="blue"
                            onClick={() => {
                                dispatch(DownloadRegisterSubmissionDocx({ id: registerState.businessRegisterIdToUpdate, infoType: 'LETTERA_CLIENTE' }))
                            }}
                        />
                        <ButtonComponent
                            size="sm"
                            iconPosition="off"
                            variant="solid"
                            label="Crea Word fase inserimento nuova attività"
                            color="blue"
                            onClick={() => {
                                dispatch(DownloadRegisterSubmissionDocx({ id: registerState.businessRegisterIdToUpdate, infoType: 'LETTERA_INSERIMENTO_ATTIVITA' }))
                            }}
                        />
                        <ButtonComponent
                            size="sm"
                            iconPosition="off"
                            variant="solid"
                            label="Crea Word Smarriti"
                            color="blue"
                            onClick={() => {
                                dispatch(DownloadRegisterSubmissionDocx({ id: registerState.businessRegisterIdToUpdate, infoType: 'LETTERA_REGISTRI_SMARRITI' }))
                            }}
                        />
                        <ButtonComponent
                            size="sm"
                            iconPosition="off"
                            variant="solid"
                            label="Crea Word Esauriti"
                            color="blue"
                            onClick={() => {
                                dispatch(DownloadRegisterSubmissionDocx({ id: registerState.businessRegisterIdToUpdate, infoType: 'LETTERA_REGISTRI_ESAURITI' }))
                            }}
                        />
                    </div>
                </div>
            </CustomAccordion>
        </div>
    )
}